export { default } from '@/models/logging.banzaicloud.io.output';
